import client from "../Client/HttpClient";
import { IEnrollmentPhysicalFoldersModel } from "@/interfaces/modules";

const ApiPath = "EnrollmentPhysicalFolders";

export default {
    /** GET api/EnrollmentPhysicalFolders */
    GetAll: (): Promise<IEnrollmentPhysicalFoldersModel[]> =>
        client.get(`${ApiPath}`),

    /** GET api/EnrollmentPhysicalFolders/{id} */
    GetById: (id: number): Promise<IEnrollmentPhysicalFoldersModel> =>
        client.get(`${ApiPath}/${id}`),

    /** GET api/EnrollmentPhysicalFolders/byFolio/{folio} */
    GetByFolio: (folio: string): Promise<IEnrollmentPhysicalFoldersModel[]> =>
        client.get(`${ApiPath}/byFolio/${encodeURIComponent(folio)}`),

    /** GET api/EnrollmentPhysicalFolders/byAcademicYear/{academicYear} */
    GetByAcademicYear: (academicYear: number): Promise<IEnrollmentPhysicalFoldersModel[]> =>
        client.get(`${ApiPath}/byAcademicYear/${academicYear}`),

    /** GET api/EnrollmentPhysicalFolders/bySite/{siteName} */
    GetBySite: (siteName: string): Promise<IEnrollmentPhysicalFoldersModel[]> =>
        client.get(`${ApiPath}/bySite/${encodeURIComponent(siteName)}`),

    /** POST api/EnrollmentPhysicalFolders */
    Post: (data: IEnrollmentPhysicalFoldersModel): Promise<IEnrollmentPhysicalFoldersModel> =>
        client.post(`${ApiPath}`, data),
};
